import { Col, Row } from 'reactstrap';
import { useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import useAuth from 'src/hooks/useAuth';
import PeriodoData from 'src/paginas/data/periodo-data.jsx';
import InputNumber from 'src/componentes/input-number';
import StatusPerdaOperacionalLookup from 'src/lookups/status-perda-operacional';
import TemplatePerdaOperacionalLookup from 'src/lookups/TemplatePerdaOperacionalLookup';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import PanelCollapse from 'src/componentes/panel-collapse';

const PerdaOperacionalSearch = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <>
      <PanelCollapse
        header={intl.formatMessage({ id: 'label.informacoesBasicas' })}
        open={true}
        ehAccordionDrawer={true}
      >
        <Row>
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TemplatePerdaOperacionalLookup
              multi
              clearable
              model={{
                label: intl.formatMessage(
                  { id: 'templateAnalisePerda' },
                  { perdaoperacional: resources.perdaoperacional }
                ),
                value: model.getModel('templatesPerdaOperacional').value,
                requestChange: model.getModel('templatesPerdaOperacional')
                  .requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <StatusPerdaOperacionalLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'status' })
                ),
                value: model.getModel('statusPerdaOperacionalList').value,
                requestChange: model.getModel('statusPerdaOperacionalList')
                  .requestChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi
              model={{
                label: capitalizeFirstLetter(resources.areas),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              clearable
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
              className="mb-3"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              multi
              abrirEmDrawer={true}
              labelComoTitulo
              data={{ somenteAtivos: true }}
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                requestChange: model.getModel('responsaveisSimplificado')
                  .requestChange,
                value: model.getModel('responsaveisSimplificado').value,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input
              type="textarea"
              rows={3}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'descricao' })
                ),
                requestChange: model.getModel('descricao').requestChange,
                value: model.getModel('descricao').value,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PeriodoData
              model={{
                label: intl.formatMessage({ id: 'labelPeriodoDataRegistro' }),
              }}
              clearable
              isDrawerFilter={true}
              data={{ idsIgnorados: [7, 8, 9, 10] }}
              tipoFiltroData={
                model.getModel('tipoFiltroDataRegistroPerdaOperacional').value
              }
              dataInicio={model.getModel('dataInicioRegistro').value}
              dataTermino={model.getModel('dataTerminoRegistro').value}
              tipoFiltroDataField={'tipoFiltroDataRegistroPerdaOperacional'}
              dataInicioField={'dataInicioRegistro'}
              dataTerminoField={'dataTerminoRegistro'}
              onChange={handleChangeFiltro}
              customLabelTipoPeriodo={capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataRegistro' })
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PeriodoData
              model={{
                label: intl.formatMessage({ id: 'labelPeriodoDataPerda' }),
              }}
              clearable
              isDrawerFilter={true}
              data={{ idsIgnorados: [7, 8, 9, 10] }}
              tipoFiltroData={
                model.getModel('tipoFiltroDataPeriodoPerdaOperacional').value
              }
              dataInicio={model.getModel('dataInicioPerda').value}
              dataTermino={model.getModel('dataTerminoPerda').value}
              tipoFiltroDataField={'tipoFiltroDataPeriodoPerdaOperacional'}
              dataInicioField={'dataInicioPerda'}
              dataTerminoField={'dataTerminoPerda'}
              onChange={handleChangeFiltro}
              customLabelTipoPeriodo={capitalizeFirstLetter(
                intl.formatMessage({ id: 'labelPeriodoDataPerda' })
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <InputNumber
              precision={2}
              model={{
                label: intl.formatMessage({ id: 'labelValorPerdaPartirDe' }),
                value: model.getModel('valorPerdaApartirDe').value,
                requestChange: (v) =>
                  model.getModel('valorPerdaApartirDe').requestChange(v),
                errors: model.getModel('valorPerdaApartirDe').errors,
              }}
            />
          </Col>
        </Row>
      </PanelCollapse>
      <PanelCollapse
        header={intl.formatMessage({ id: 'informacoesDeOrigem' })}
        open={false}
        ehAccordionDrawer={true}
      >
        <Row>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi
              model={{
                label: intl.formatMessage({ id: 'areasGeradoras' }),
                value: model.getModel('areasGeradoras').value,
                requestChange: model.getModel('areasGeradoras').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              clearable
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: intl.formatMessage({ id: 'areasGeradoras' }) }
                ),
                value: model.getModel('areasGeradorasSubordinadas').value,
                requestChange: model.getModel('areasGeradorasSubordinadas')
                  .requestChange,
              }}
              className="mb-3"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              multi
              abrirEmDrawer={true}
              labelComoTitulo
              model={{
                label: intl.formatMessage({ id: 'responsaveisPelaAnalise' }),
                requestChange: model.getModel('responsaveisAnalise')
                  .requestChange,
                value: model.getModel('responsaveisAnalise').value,
              }}
              data={{ somenteAtivos: true }}
            />
          </Col>
        </Row>
      </PanelCollapse>
      {model.getModel('camposCustomizados')?.value &&
        model.getModel('camposCustomizados').value.length > 0 && (
          <PanelCollapse
            header={intl.formatMessage({ id: 'informacoesComplementares' })}
            open={false}
            ehAccordionDrawer={true}
          >
            <Row>
              <Col md={12}>
                <DesenharCampoCustomizado
                  model={model.getModel('camposCustomizados')}
                  mdFields={12}
                />
              </Col>
            </Row>
          </PanelCollapse>
        )}
    </>
  );
};
export default PerdaOperacionalSearch;
